import { render } from "./ClientDashboard.html?vue&type=template&id=8d6d5a4a&external"
import script from "./ClientDashboard.js?vue&type=script&lang=js&external"
export * from "./ClientDashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__